import React from 'react';
import { Col, Row, Tooltip } from 'antd';

import { InfoCircleOutlined } from '@ant-design/icons';

import isEmpty from 'lodash/isEmpty';

import {
  useGetTooltipContentByFieldPath,
  useGetTooltipForMember,
} from 'pages/help-content-management/hooks/useGetTooltipForMember';

import TraceableCommentContainer from 'pages/traceable-comment/TraceableCommentContainer';
import { getFormattedPath } from 'pages/qa-spec/components/shared/QaSpecHelper';

export const QaSpecHelpContentLabel = ({
  fieldPath = '',
  tooltip,
  style = {},
  isEnabled: isEnabledProp = true,
  children,
  ...rest
}) => {

  const { isExistTooltipContentByPath, getTooltipContentByPath } =
    useGetTooltipContentByFieldPath();

  const { flattenedTooltipFields } = useGetTooltipForMember();

  const isExistTooltips = !isEmpty(flattenedTooltipFields);

  if (
    isEnabledProp &&
    isExistTooltips &&
    isExistTooltipContentByPath(fieldPath)
  ) {
    const tooltip = getTooltipContentByPath(fieldPath);

    return (
      <>
        {children}
        <Tooltip title={tooltip} color='#238dd9' {...rest}>
          <InfoCircleOutlined
            style={{
              paddingLeft: '5px',
              marginRight: 2,
              fontSize: '14px',
              color: '#6c757d',
              ...style,
            }}
          />
        </Tooltip>
      </>
    );
  }

  return children;
};

export const QaSpecHelpContentGridLabel = ({
  displayName,
  fieldPath,
  qaSpecName,
  ...rest
}) => {
  return (
    <TraceableCommentContainer
      qaSpecName={
        qaSpecName
          ? qaSpecName
          : getFormattedPath(fieldPath) ===
            'Allergens Allergen Related Information Allergen'
          ? 'Allergens'
          : getFormattedPath(fieldPath)
      }
      qaSpecFieldName={displayName}
    >
      <QaSpecHelpContentLabel fieldPath={fieldPath} {...rest}>
        {displayName}
      </QaSpecHelpContentLabel>
    </TraceableCommentContainer>
  );
};

export const QaSpecHelpContentWithoutLabel = ({
  fieldPath = '',
  tooltip,
  style = {},
  isEnabled: isEnabledProp = true,
  children,
  ...rest
}) => {
  const { isExistTooltipContentByPath, getTooltipContentByPath } =
    useGetTooltipContentByFieldPath();

  // Create a child with form binding props preserved
  const childWithProps = React.isValidElement(children)
    ? React.cloneElement(children, rest)
    : children;

  if (isExistTooltipContentByPath(fieldPath) && isEnabledProp) {
    const tooltipContent = getTooltipContentByPath(fieldPath);

    return (
      <Row align='middle'>
        <Col flex='auto'>{childWithProps}</Col>
        <Col flex='10px'>
          <Tooltip title={tooltipContent} color='#238dd9'>
            <InfoCircleOutlined
              style={{
                paddingLeft: '5px',
                marginRight: 2,
                fontSize: '14px',
                color: '#6c757d',
                ...style,
              }}
            />
          </Tooltip>
        </Col>
      </Row>
    );
  }

  return childWithProps;
};
